import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateInPipe } from './translate-in.pipe';



@NgModule({
  declarations: [
    TranslateInPipe
  ],
  exports: [
    TranslateInPipe
  ],
  imports: [
    CommonModule
  ]
})
export class TranslateInPipeModule { }
